import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import {
  BookOutlined,
  ClockCircleOutlined,
  AppstoreOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

const formatTime = (t) => {
  if (!t || t === "00:00:00") return null;
  const [h, m] = t.split(":").map((n) => parseInt(n, 10));
  if (!h && !m) return null;
  if (!h) return `${m}m`;
  if (!m) return `${h}h`;
  return `${h}h ${m}m`;
};

const RecommendedCoursesCard = ({ recommendedCourses = [], style = {} }) => {
  const navigate = useNavigate();

  if (!recommendedCourses || recommendedCourses.length === 0) return null;

  const openCourse = (course) => {
    if (course.isEnrolled && course.enrollmentId) {
      navigate(`/selfLearner-dashboard/enrolled-courses/courses/${course.enrollmentId}`);
      return;
    }

    navigate(`/selfLearner-dashboard/available-courses/courses/${course.id}`);
  };

  return (
    <section className="sl-section" style={style}>
      <div className="sl-section__head">
        <h2 className="sl-section__title">
          Recommended for you
          <small>Matched to your focus areas</small>
        </h2>
        <button
          type="button"
          className="sl-section__link"
          onClick={() => navigate("/selfLearner-dashboard/available-courses")}
        >
          Browse all <ArrowRightOutlined />
        </button>
      </div>

      <div className="sl-grid">
        {recommendedCourses.map((course) => {
          const time = formatTime(course.estimatedTime);
          const modules = course.moduleCount || 0;
          return (
            <div
              key={course.id}
              className="sl-card"
              role="button"
              tabIndex={0}
              onClick={() => openCourse(course)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openCourse(course);
                }
              }}
            >
              <div className="sl-card__media">
                <BookOutlined />
                {course.isEnrolled && <span className="sl-badge">Enrolled</span>}
              </div>
              <div className="sl-card__body">
                <h3 className="sl-card__title">{course.title}</h3>
                {course.description && <p className="sl-card__desc">{course.description}</p>}
                <div className="sl-card__meta">
                  {time && (
                    <span>
                      <ClockCircleOutlined /> {time}
                    </span>
                  )}
                  <span>
                    <AppstoreOutlined /> {modules} module{modules !== 1 ? "s" : ""}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

RecommendedCoursesCard.propTypes = {
  recommendedCourses: PropTypes.array,
  style: PropTypes.object,
};

export default RecommendedCoursesCard;
